import { Component } from '@angular/core';
import { CloudinaryOptions, CloudinaryUploader } from 'ng2-cloudinary';
import { NgForm } from '@angular/forms';
import {AngularFireDatabase, FirebaseListObservable, FirebaseObjectObservable} from 'angularfire2/database';
import { Router, ActivatedRoute } from "@angular/router";
import { ToastrService } from 'toastr-ng2';
const swal = require('sweetalert');

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.scss']
})
export class CategoriesComponent  {

     siteVal:any;
     categories:Array<any>;
     categoryData: FirebaseListObservable<any>;

    constructor(public af:AngularFireDatabase, public router:Router,public toastr: ToastrService) {
     this.categoryData= af.list('/categories');
         this.categoryData.subscribe((res)=>{
           console.log("categories" + JSON.stringify(res));
         this.categories = res;
     }); 
    }


  getCategory(ev: any) {
        let val = ev;
        this.categoryData = this.af.list('/categories', {
            query: {
                orderByChild: 'title',
                startAt: val.charAt(0).toUpperCase() + val.slice(1),
                endAt: val.charAt(0).toUpperCase() + val.slice(1) + '\uf8ff'
            }
        });
        this.categoryData
            .subscribe((data) => {
                this.categories = data;
            });


    }


   categoryShow(key){
     this.router.navigate(['/categories/viewCategory', key]);
  }
  
   categoryEdit(key){
    this.router.navigate(['/categories/editCategory', key]);
  }

categoryDelete(key:any){
   swal({
            title: 'Are you sure?',
            text: 'Your will not be able to recover this imaginary file!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
            closeOnConfirm: false,
            closeOnCancel: false
        }, (isConfirm) => {
            if (isConfirm) {
               this.categoryData.remove(key).then((res)=>{
                   swal('Deleted!','Categories Data Deleted Successfully!', 'success');
                 })
              } else {
                swal('Cancelled', 'Your data is safe :)', 'error');
            }
        });
  }

}



// WEBPACK FOOTER //
// /Users/sooweeseng/Documents/Ionic Apps/FoonYew2_Backend_ok_version/webapp/src/app/routes/restaurant/categories/categories.component.ts